/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTrendHotelFocusOn,
  selectTrendTimeDateComparison,
  selectEnableSecondaryHotelGroups,
  selectIsPrimary,
} from 'modules/dashboard/components/tab-container/trend-tabs/selectors';
import { selectEnableHotelGroups, selectHotelName } from 'modules/dashboard/selectors';
import { trendActions } from 'modules/dashboard/components/tab-container/trend-tabs/slice';
import { REPORT_TYPE } from 'modules/dashboard/constants';
// Custom hook to determine the displayed visual type based on hotel selection and date comparison
const UseVisualSwap = () => {
  const dispatch = useDispatch();
  const dateComparison = useSelector(selectTrendTimeDateComparison);
  const hotelFocusOn = useSelector(selectTrendHotelFocusOn);
  const selectedHotel = useSelector(selectHotelName);
  const enableHotelGroups = useSelector(selectEnableHotelGroups);
  const enableSecondaryHotelGroups = useSelector(selectEnableSecondaryHotelGroups);
  const isPrimary = useSelector(selectIsPrimary);
  /**
   * Different hotels/ hotel groups selected in primary and secondary dropdowns -> Display Trend Hotel visuals
   * Same hotel/ hotel group selected in primary and secondary dropdowns AND only 'PRIMARY' option selected on date comparison -> Display Trend Segment visuals
   * Else -> Display Trend Time visuals
   */
  useEffect(() => {
    if (isPrimary) {
      dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_SEGMENT));
    } else if (hotelFocusOn?.id !== selectedHotel?.id) {
      dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_HOTEL));
    } else {
      dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_TIME));
    }
  }, [
    dateComparison,
    hotelFocusOn,
    selectedHotel,
    enableHotelGroups,
    enableSecondaryHotelGroups,
    isPrimary,
  ]);

  // useEffect(() => {
  //   if (hotelFocusOn?.id !== selectedHotel?.id) {
  //     dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_HOTEL));
  //   } else if (isPrimary) {
  //     dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_SEGMENT));
  //   } else {
  //     dispatch(trendActions.setActiveTrendTab(REPORT_TYPE.TREND_TIME));
  //   }
  // }, [
  //   dateComparison,
  //   hotelFocusOn,
  //   selectedHotel,
  //   enableHotelGroups,
  //   enableSecondaryHotelGroups,
  //   isPrimary,
  // ]);
};
//
export default UseVisualSwap;
